// RB-MY01-PalmGarden.web/src/components/PlantForm/components/FormSections/FloralDetails.tsx
import React from 'react';
import { Box, Typography } from '@mui/material';
import SectionCard from '../SectionCard';
import { FormSectionProps } from '../../types';
import { sectionThemes } from '../../styles';

const FloralDetails: React.FC<FormSectionProps> = ({ 
  plant
}) => {
  return (
    <SectionCard 
      title="Floral Details" 
      icon={<i className={sectionThemes.floralDetails.iconName} style={{ marginRight: '8px' }} />}
      theme={{ color: sectionThemes.floralDetails.color }}
    >
      <Box sx={{ p: 2 }}>
        <Typography>
          Floral Details section is under construction.
        </Typography>
      </Box>
    </SectionCard>
  );
};

export default React.memo(FloralDetails);
